module.exports = __webpack_public_path__ + "img/JoeWahba_O_5.f7e4daf5.jpg";